<div [formGroup]="form()">
    <h4>Agents</h4>
    <div class="d-flex flex-column w-100 flex-wrap">
        <div class="d-flex flex-column  w-100 mb-2">
            <label class="input-label">{{ 'handler' | translate }}</label>
            <div class="d-flex agents">
                <button (click)="toggleHasToIncludeInactiveAgents()" pButton
                    pTooltip="Permet d'inclure ou non les agents inactifs" class=" w-25" id="agents-toggler">
                    {{hasToIncludeInactiveAgents() ?
                    'Tous les utilisateurs' :
                    'Agents actifs'}}
                </button>
                <p-multiSelect [virtualScroll]="true" [itemSize]="30" [options]="agents()" [loading]="fetchingAgents()"
                    [disabled]="fetchingAgents()" #AgentsMultiSelect formControlName="agents"
                    [placeholder]="'selectOneOrMoreAUser'| translate" id="agents-multi-select" appendTo="body"
                    [filter]="true" [resetFilterOnHide]="true" [filterBy]="'nom,prenom'" class="w-100"
                    [style]="{width: '100%'}" [ngStyle]="{width: '100%'}" styleClass="w-100">
                    <ng-template pTemplate="selectedItems" let-items>
                        <div class="d-inline-flex align-items-center">
                            @for(item of items; track item.nom; let last = $last) {
                            {{item.nom | uppercase}} {{item.contactForUser.prenom ?? ''}}
                            @if(!last) {
                            <span>, </span>

                            }

                            }
                        </div>
                    </ng-template>
                    <ng-template pTemplate="item" let-item>
                        <div class="inline-flex align-items center">
                            {{item.nom | uppercase}} {{item.contactForUser.prenom ?? ''}}
                        </div>
                    </ng-template>

                </p-multiSelect>
            </div>
        </div>
        <div class="d-flex flex-column  w-100">
            <label class="input-label">{{ 'creator' | translate }}</label>
            <div class="d-flex users w-100">
                <button (click)="toggleHasToIncludeInactiveUsers()" pButton
                    pTooltip="Permet d'inclure ou non les créateurs inactifs" class="w-25" id="users-toggler">
                    {{hasToIncludeInactiveUsers() ?
                    'Tous les créateurs' :
                    'Créateurs actifs'}}
                </button>
                <p-multiSelect [virtualScroll]="true" [itemSize]="30" class="fullWidth" [options]="users()"
                    [loading]="fetchingUsers()" [disabled]="fetchingUsers()" formControlName="users"
                    [placeholder]="'Sélectionner un ou plusieurs créateurs'" appendTo="body" [filter]="true"
                    id="users-multi-select" [resetFilterOnHide]="true" class="w-100" [style]="{width: '100%'}"
                    [ngStyle]="{width: '100%'}" styleClass="w-100" [filterBy]="'nom,prenom'">
                    <ng-template pTemplate="selectedItems" let-items>
                        <div class="d-inline-flex align-items-center">
                            @for(item of items; track item.nom; let last = $last) {
                            {{item.nom | uppercase}} {{item.contactForUser.prenom ?? ''}}
                            @if(!last) {
                            <span>, </span>

                            }

                            }
                        </div>
                    </ng-template>
                    <ng-template pTemplate="item" let-item>
                        <div class="inline-flex align-items center">
                            {{item.nom | uppercase}} {{item.contactForUser.prenom ?? ''}}
                        </div>
                    </ng-template>

                </p-multiSelect>
            </div>
        </div>
    </div>
</div>